import React from "react";

const Stat_Quartiles_and_Percentiles = () => {
  return (
    <div>
      <h1>Stat Quartiles and Percentiles</h1>
    </div>
  );
};

export default Stat_Quartiles_and_Percentiles;
